import React from 'react';
import { ColumnProps } from '@common-ui-library/molecule';
import { Box } from '@common-ui-library/atom';
import { adminChip } from '../../Utils/utils';
import { Provider } from '../../Utils/types';

interface ProviderColumnPropsType extends ColumnProps {
  exportValue?: (value: Provider) => string;
}

// Helper to check if provider is inactive
const isInactive = (provider: Provider) => provider?.owner?.account_status === 'deactivated';

// Style for inactive rows
const getRowStyle = (provider: Provider) => isInactive(provider) ? { opacity: 0.5 } : {};

const providerColumnProps: ProviderColumnPropsType[] = [
  {
    key: 'name',
    header: 'Name',
    width: '35%',
    exportValue: (provider: Provider) => `${provider.name} (${provider.email})`,
    render: (provider: Provider) => {
      return (
        <Box sx={getRowStyle(provider)}>
          <Box style={{ fontWeight: 500 }}>
            {provider?.name} {adminChip(provider?.roles)}
          </Box>
          <Box sx={{ color: 'text.secondary', fontSize: '0.875em' }}>
            {provider?.email}
          </Box>
        </Box>
      );
    },
  },
  {
    key: 'profession',
    header: 'Profession',
    width: '20%',
    render: (provider: Provider) => (
      <Box sx={getRowStyle(provider)}>{provider?.profession}</Box>
    ),
  },
  {
    key: 'site',
    header: 'Site',
    width: '15%',
    exportValue: (provider: Provider) => provider?.site?.[0]?.name ?? '',
    render: (provider: Provider) => {
      const siteName = provider?.site?.[0]?.name ?? '';
      return (
        <Box sx={getRowStyle(provider)}>
          {siteName}
        </Box>
      );
    },
  },
  {
    key: 'program',
    header: 'Program',
    width: '0%',
  },
];

export default providerColumnProps;
